import "../../css/userPage/MyInfo.css"
import {limitInputNumber, setInvalidMessage} from "../../utils/Utils";
import {useState} from "react";
import UserPasswordResetModal from "../admin/userManagement/modal/UserPasswordResetModal";
import UserEditInfo from "../../utils/UserEditInfo";
import proxy from "../../utils/Proxy";

let MyInfoPage = (props) => {
    let [passwordModalOpened, setPasswordModalOpened] = useState(false);
    let onClickSave = (_) => {
        let body = {};
        let invalidList = [];
        for (let index in UserEditInfo.editableTextInputs) {
            let dataName = UserEditInfo.editableTextInputs[index];
            let inputName = UserEditInfo.getInputName(dataName)
            let input = document.querySelector("input[name='" + inputName + "']");
            if (input === null)
                continue;
            if (!input.validity.valid) {
                invalidList.push(UserEditInfo.labels[UserEditInfo.dataName.indexOf(dataName)])
                let invalidMessageIndex = UserEditInfo.editRequired.indexOf(dataName);
                let invalidMessage = UserEditInfo.invalidMessages[UserEditInfo.editInvalid[invalidMessageIndex]]
                setInvalidMessage(input, UserEditInfo.getInvalidMessageId(dataName), invalidMessage)
                continue;
            }
            if (input.defaultValue !== input.value)
                body[dataName] = input.value;
        }
        let checkbox = document.getElementById("myinfo-subscribe-checkbox");
        body["subscribed"] = checkbox.checked;

        if (invalidList.length > 0) {
            let invalidText = "";
            for (let invalid of invalidList) {
                invalidText += invalid + ", "
            }
            invalidText = invalidText.slice(0, -2);
            window.alert("잘못된 형식입니다.\n(" + invalidText + ")")
        }
        proxy.put("/api/myInformation", body).then(_ => {
            window.alert("저장되었습니다.");
            props.setNeedInfoRefresh(true)
        }).catch((res) => {
            window.alert(res.response.data.message)
        })
    }
    let getInfos = () => {
        const info = UserEditInfo;
        let ret = [];
        for (let i = 0; i < info.dataName.length; i++) {
            let label = info.labels[i];
            let dataName = info.dataName[i]
            let invalidMessageId = info.getInvalidMessageId(dataName);
            let inputName = info.getInputName(dataName);
            let key = label + dataName;
            if (dataName === "subscribed") {
                ret.push(<li key={key}>
                    <div className="myinfo-item">
                        <div className="myinfo-item-label">
                            <p>{label}</p>
                        </div>
                        <div className="myinfo-item-input-container">
                            <input type="checkbox" id="myinfo-subscribe-checkbox" defaultChecked={props.myInformation["subscribed"]}/>
                        </div>
                    </div>
                </li>)
            } else if (dataName === "password") {
                ret.push(<li key={key}>
                    <div className="myinfo-item">
                        <div className="myinfo-item-label">
                            <p>비밀번호</p>
                        </div>
                        <div className="myinfo-item-input-container">
                            <div className="myinfo-item-input"
                                 id="myinfo-password-change"
                                 onClick={() => setPasswordModalOpened(true)}>
                                <p>변경</p>
                            </div>
                        </div>
                    </div>
                </li>)
            } else if (info.editableTextInputs.indexOf(dataName) !== -1) {
                let inputIndex = info.editableTextInputs.indexOf(dataName);
                let invalidMessage = inputIndex !== -1 ? info.invalidMessages[info.editInvalid[inputIndex]] : ""
                let textLimit = info.editableTextLimits[inputIndex]
                let pattern = info.editableTextRegex[inputIndex]
                let isRequired = info.editRequired.indexOf(dataName) !== -1;
                ret.push(<li key={key}>
                    <div className="myinfo-item">
                        <div className="myinfo-item-label">
                            <p>{label}</p>
                        </div>
                        <div className="myinfo-item-input-container">
                            <input className="myinfo-item-input"
                                   defaultValue={info.getDataString(dataName, props.myInformation[dataName])}
                                   name={inputName}
                                   onChange={(e) => {
                                       limitInputNumber(e, textLimit)
                                       setInvalidMessage(e.target, invalidMessageId, invalidMessage)
                                   }}
                                   pattern={pattern} required={isRequired}
                            />
                            <p className="myinfo-invalid-message" id={invalidMessageId}></p>
                        </div>
                    </div>
                </li>)

            } else {
                ret.push(<li key={key}>
                    <div className="myinfo-item">
                        <div className="myinfo-item-label">
                            <p>{label}</p>
                        </div>
                        <div className="myinfo-item-input-container">
                            {info.getDataString(dataName, props.myInformation[dataName])}
                        </div>
                    </div>
                </li>)
            }
        }
        return ret;
    }
    return (<>
        <div className="content-container">
            <div className="content-title">
                <p>내 정보</p>
            </div>
            <ul className="myinfo-container">
                {getInfos()}
                <div className="myinfo-item" id="myinfo-button-container">
                    <div className="myinfo-item-input" id="myinfo-save-button" onClick={e => onClickSave(e)}>
                        <p>변경 사항 저장</p>
                    </div>
                </div>
            </ul>
        </div>
        {passwordModalOpened ? <UserPasswordResetModal isAdmin={false}
                                                       onCloseClick={() => setPasswordModalOpened(false)}/> : null}
    </>)
}
export default MyInfoPage;